import { StoreApi, UseBoundStore, useStore } from "zustand";
import { MailChatStoreType, mailChatStore } from "./email-chat-store";
import {
  mailChatPersistentStore,
  MailChatPersistentStoreType,
} from "./email-chat-persistent-store";

export const useMailChatStore = useStore.bind(
  null,
  mailChatStore.getStore()
) as UseBoundStore<StoreApi<MailChatStoreType>>;

export const useMailChatPersistentStore = useStore.bind(
  null,
  mailChatPersistentStore.getStore()
) as UseBoundStore<StoreApi<MailChatPersistentStoreType>>;
